<template>
  <v-container>
    <div>
      <v-btn color="primary" @click="back" class="noprint mr-3">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
    </div>
    <div class="mt-3">
      <iframe
        :src="url"
        frameborder="0"
        type="application/pdf"
        width="100%"
        height="800px"
      ></iframe>
    </div>
  </v-container>
</template>

<script>
import "jspdf-autotable";
import { jsPDF } from "jspdf";
import moment from "moment";

export default {
  props: {
    id: Number,
  },
  data() {
    return {
      salePayment: {},
      url: "",
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    async getSaleDownPayment() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("salePayment/getVoucher", this.id)
        .then(response => {
          this.salePayment = response.data;
          this.createPdf();
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      if (value === null) {
        return "";
      }
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    createListAccount() {
      let array = [];
      this.salePayment.accounts.forEach(x => {
        array.push([
          x.accountName,
          { content: this.formatPrice(x.debit), styles: { valign: "middle", halign: "right" } },
          { content: this.formatPrice(x.credit), styles: { valign: "middle", halign: "right" } },
          { content: this.formatPrice(x.debitIDR), styles: { valign: "middle", halign: "right" } },
          { content: this.formatPrice(x.creditIDR), styles: { valign: "middle", halign: "right" } },
        ]);
      });
      return array;
    },
    createListItem() {
      let array = [];
      this.salePayment.items.forEach(x => {
        array.push([
          `P${x.reference}`,
          x.desc,
          { content: this.formatPrice(x.amount), styles: { valign: "middle", halign: "right" } },
          { content: this.formatPrice(x.amountIDR), styles: { valign: "middle", halign: "right" } },
        ]);
      });
      return array;
    },
    createListItemV2() {
      let reffs = this.salePayment.items.map(x => x.reference).join(",");
      return [
        [
          `P${this.salePayment.items[this.salePayment.items.length - 1].reference}`,
          `Payment A/R ${reffs} FROM ${this.salePayment.customerName}`,
          {
            content: this.formatPrice(this.salePayment.total),
            styles: { valign: "middle", halign: "right" },
          },
          {
            content: this.formatPrice(this.salePayment.totalIDR),
            styles: { valign: "middle", halign: "right" },
          },
        ],
      ];
    },
    createPdf() {
      const doc = new jsPDF();

      doc.setFont("Times", "bold");
      doc.setFontSize(20);
      doc.text("PT. GRAHA SUMBER PRIMA ELEKTRONIK", 30, 20);
      doc.setFontSize(16);
      doc.text("RECEIPT VOUCHER", 80, 30);

      doc.setFont("Times", "normal");
      doc.setFontSize(10);
      doc.rect(60, 35, 6, 6);
      doc.text("CASH", 71, 39);
      doc.rect(100, 35, 6, 6);
      doc.text("BANK", 111, 39);
      doc.text("NO : ", 151, 39);

      doc.rect(5, 45, 200, 10);
      doc.setFont("Times", "normal");
      doc.setFontSize(10);
      doc.text("SOURCE CODE", 7, 51);
      doc.rect(45, 47, 6, 6);
      doc.rect(53, 47, 6, 6);

      doc.text("VOUCHER NO.", 70, 51);
      doc.rect(100, 47, 6, 6);
      doc.rect(108, 47, 6, 6);
      doc.rect(116, 47, 6, 6);
      doc.rect(124, 47, 6, 6);
      doc.rect(132, 47, 6, 6);

      doc.text("DATE :", 147, 51);
      doc.rect(160, 47, 30, 6);
      doc.text(moment(this.salePayment.date).format("DD-MM-yyyy"), 162, 51);

      doc.autoTable({
        margin: { left: 5, right: 5 },
        startY: 55,
        theme: "plain",
        tableLineWidth: 0.1,
        tableLineColor: "black",
        head: [
          [
            {
              rowSpan: 2,
              content: "ACCOUNT NAME",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "bold" },
            },
            {
              colSpan: 2,
              content: "ORIGINAL CURRENCY",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "bold" },
            },
            {
              colSpan: 2,
              content: "EQUIVALEN IN RP",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "bold" },
            },
          ],
          [
            {
              content: "Debit",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "bold" },
            },
            {
              content: "Credit",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "bold" },
            },
            {
              content: "Debit",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "bold" },
            },
            {
              content: "Credit",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "bold" },
            },
          ],
        ],
        body: [
          ...this.createListAccount(),
          [
            {
              content: "TOTAL",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "bold" },
            },
            {
              content: `${this.formatPrice(this.salePayment.totalDebit)}`,
              styles: { valign: "middle", halign: "right", lineWidth: 0.1, fontStyle: "bold" },
            },
            {
              content: `${this.formatPrice(this.salePayment.totalCredit)}`,
              styles: { valign: "middle", halign: "right", lineWidth: 0.1, fontStyle: "bold" },
            },
            {
              content: `${this.formatPrice(this.salePayment.totalDebitIDR)}`,
              styles: { valign: "middle", halign: "right", lineWidth: 0.1, fontStyle: "bold" },
            },
            {
              content: `${this.formatPrice(this.salePayment.totalCreditIDR)}`,
              styles: { valign: "middle", halign: "right", lineWidth: 0.1, fontStyle: "bold" },
            },
          ],
        ],
        styles: {
          tableWidth: "auto",
          lineColor: "black",
          font: "times",
          fontSize: 9,
        },
        didDrawCell: data => {
          if (data.row.section === "body" && data.column.dataKey >= 0) {
            let x = data.cell.x + data.cell.width;
            let y = data.cell.y + data.cell.height;
            data.doc.setDrawColor(0);
            data.doc.line(x, data.cell.y, x, y);
          }
        },
      });

      const y1 = doc.lastAutoTable.finalY + 10;

      doc.autoTable({
        margin: { left: 5, right: 5 },
        startY: y1,
        theme: "plain",
        head: [["REF", "DESCRIPTION", "AMOUNT", "EQIN RP"]],
        body: [
          ...this.createListItemV2(),
          [
            "",
            {
              content: "TOTAL : ",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "normal" },
            },
            {
              content: this.formatPrice(this.salePayment.total),
              styles: { valign: "middle", halign: "right", lineWidth: 0.1, fontStyle: "normal" },
            },
            {
              content: this.formatPrice(this.salePayment.totalIDR),
              styles: { valign: "middle", halign: "right", lineWidth: 0.1, fontStyle: "normal" },
            },
          ],
        ],
        styles: {
          valign: "middle",
          tableWidth: "auto",
          lineWidth: 0.1,
          halign: "left",
          lineColor: "black",
        },
        headStyles: {
          valign: "middle",
          halign: "center", //'center' or 'right',
          tableWidth: "auto",
        },
      });

      const y2 = doc.lastAutoTable.finalY + 5;
      doc.setDrawColor(0);
      doc.rect(5, y2, 200, 40);
      doc.setFont("Times", "bold");
      doc.setFontSize(10);
      doc.text("Receive From :", 7, y2 + 5);
      doc.text(this.salePayment.customerName, 35, y2 + 5);
      doc.text("Received by :", 107, y2 + 5);
      doc.setFont("Times", "normal");
      doc.setFontSize(10);
      doc.text("(                                          )", 107, y2 + 35);
      doc.setFont("Times", "bold");
      doc.setFontSize(10);
      doc.text("Date : ", 157, y2 + 35);
      doc.setDrawColor(0);
      doc.line(167, y2 + 35, 193, y2 + 35);

      doc.autoTable({
        margin: { left: 5, right: 5 },
        startY: y2 + 45,
        theme: "plain",
        head: [["PREPARED BY :", "CHECKED BY :", "APPROVALS :"]],
        body: [
          [
            {
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "normal" },
            },
            {
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "normal" },
            },
            {
              content: "",
              styles: { valign: "middle", halign: "center", lineWidth: 0.1, fontStyle: "normal" },
            },
          ],
        ],
        styles: {
          valign: "middle",
          tableWidth: "auto",
          lineWidth: 0.1,
          halign: "left",
          lineColor: "black",
          minCellHeight: 30,
        },
        headStyles: {
          valign: "middle",
          halign: "center", //'center' or 'right',
          tableWidth: "auto",
          minCellHeight: 0,
        },
      });

      this.url = doc.output("datauristring");
    },
  },
  created() {
    this.getSaleDownPayment();
  },
};
</script>

<style></style>
